import { useState } from "react";
import { CheckSquare, ChevronRight, Clipboard, MessageSquare, Ship } from "lucide-react";

const DashboardTile =({result})=> {

  return (
    <div className="">
      <main className="">


        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          
          <div class="group relative card custom-card overflow-hidden main-content-card py-5">
            <div class="flex justify-between px-6 items-center h-full">
              <div className="flex flex-col justify-center items-start h-full relative z-10 space-y-2">
                <div className="text-[14px] font-semiboldtext-[#222]">
                  Total Vessels
                </div>
                <div>
                  <span className="font-bold text-[30px]">{result?.totalVessels}</span>
                </div>
              </div>
              <div>
                <div className="w-10 h-10 rounded-full bg-[#5c67f7] flex items-center justify-center shadow-md">
                  <Ship size={20} className="text-white" />
                </div>
              </div>
            </div>
          </div>

          <div class="group relative card custom-card overflow-hidden main-content-card py-5">
            <div class="flex justify-between px-6 items-center h-full">
              <div className="flex flex-col justify-center items-start h-full relative z-10 space-y-2">
                <div className="text-[14px] font-semiboldtext-[#222]">
                  Today's Actions
                </div>
                <div>
                  <span className="font-bold text-[30px]">{result?.todayActions}</span>
                </div>
              </div>
              <div>
                <div className="w-10 h-10 rounded-full bg-[#E354D4] flex items-center justify-center shadow-md">
                  <CheckSquare size={20} className="text-white" />
                </div>
              </div>
            </div>
          </div>

          <div class="group relative card custom-card overflow-hidden main-content-card py-5">
            <div class="flex justify-between px-6 items-center h-full">
              <div className="flex flex-col justify-center items-start h-full relative z-10 space-y-2">
                <div className="text-[14px] font-semiboldtext-[#222]">
                  Today's Comments
                </div>
                <div>
                  <span className="font-bold text-[30px]">{result?.todayComments}</span>
                </div>
              </div>
              <div>
                <div className="w-10 h-10 rounded-full bg-[#FF5D9F] flex items-center justify-center shadow-md">
                  <MessageSquare size={20} className="text-white" />
                </div>
              </div>
            </div>
          </div>

          <div class="group relative card custom-card overflow-hidden main-content-card py-5">
            <div class="flex justify-between px-6 items-center h-full">
              <div className="flex flex-col justify-center items-start h-full relative z-10 space-y-2">
                <div className="text-[14px] font-semiboldtext-[#222]">
                  Weekly Inspections
                </div>
                <div>
                  <span className="font-bold text-[30px]">{result?.weeklyInspection}</span>
                </div>
              </div>
              <div>
                <div className="w-10 h-10 rounded-full bg-[#FF8E6F] flex items-center justify-center shadow-md">
                  <Clipboard size={20} className="text-white" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
}

export default DashboardTile;